import {useAtomEffect} from '@/utils/jotai/useAtomEffect'

import {accountInformationAtom} from './useAccountInformation'

export const isAuthenticatedAtom = atom(get => {
  const accountInformation = get(accountInformationAtom)
  return !!accountInformation
})

export default function useIsAuthenticated() {
  return useIsAuthenticatedValue()
}

export function useIsAuthenticatedValue() {
  return useAtomValue(isAuthenticatedAtom)
}

export function useGetIsAuthenticated() {
  const store = useStore()
  return useCallback(() => store.get(isAuthenticatedAtom), [store])
}

export function useAuthEffect(authDispatch: (value: boolean, get?: Getter, set?: Setter) => void) {
  useAtomEffect(isAuthenticatedAtom, authDispatch)
}
